import React from 'react';
import InterpolateLink from 'src/viewLayer/components/shared/InterpolateLink';
import { useBusinessPrivacyPath, useBusinessDataPath } from 'src/viewLayer/navigation';
import { t } from 'src/viewLayer/helpers/translations';

const DataProcessingSection = () => {
  const businessPrivacyLink = {
    name: 'businessPrivacyLink',
    path: useBusinessPrivacyPath(),
    translation: t('login.b2b.data_processing.business_privacy_link')
  };

  const businessDataLink = {
    name: 'businessDataLink',
    path: useBusinessDataPath(),
    translation: t('login.b2b.data_processing.business_data_link')
  };

  return (
    <div className="data-processing">
      <p className="data-processing-title">{ t('login.b2b.data_processing.title') }</p>
      <InterpolateLink
        translation={t('login.b2b.data_processing.legal_copy')}
        firstLink={ businessPrivacyLink }
        secondLink={ businessDataLink }
      />
    </div>
  );
};

export default DataProcessingSection;
